import React, { Component } from 'react';
import { Link, Switch, Route, Redirect } from 'react-router-dom';
import { Container } from 'reactstrap';
import Header from '../../components/Header/';
import Sidebar from '../../components/Sidebar/';
import Aside from '../../components/Aside/';

import Dashboard from 'views/Dashboard';
import Log from 'views/Log';
import Reports from 'views/Reports';
import Report from 'views/Report';
import Surveys from 'views/Surveys';
import Survey from 'views/Survey';
import Topics from 'views/Topics';
import Topic from 'views/Topic';
import Appointments from 'views/Appointments';
import Employees from 'views/Employees';
import Assignments from 'views/Assignments';
import Assignment from 'views/Assignment';

class Full extends Component {
  render() {
    return (
      <div className="app">
        <Header />
        <div className="app-body">
          <Sidebar {...this.props} />
          <main className="main">
            <Container fluid>
              <Switch>
                {/*<Route
                  path="/dashboard"
                  name="Dashboard"
                  component={Dashboard}
                />*/}
                <Route path="/reports" name="Meldungen" component={Reports} />
                <Route
                  path="/report/:reportId"
                  name="Meldung"
                  component={Report}
                />
                <Route path="/surveys" name="Umfragen" component={Surveys} />
                <Route
                  path="/survey/:surveyId"
                  name="Umfrage"
                  component={Survey}
                />
                <Route path="/topics" name="Themen" component={Topics} />
                <Route path="/topic/:topicId" name="Thema" component={Topic} />
                <Route
                  path="/appointments"
                  name="Termine"
                  component={Appointments}
                />
                <Route
                  path="/employees"
                  name="Mitarbeiter"
                  component={Employees}
                />
                <Route
                  path="/assignments"
                  name="Aufgaben"
                  component={Assignments}
                />
                <Route
                  path="/assignment/:assignmentId"
                  name="Aufgabe"
                  component={Assignment}
                />
                <Route path="/log" name="Logbuch" component={Log} />
              </Switch>
            </Container>
          </main>
          <Aside />
        </div>
      </div>
    );
  }
}

export default Full;



// WEBPACK FOOTER //
// ./src/containers/Full/Full.js